import {
	SECTIONSTATES,
	SKYC_KEY_NAME,
	SKYC_MODULE_NAME,
	STATES,
} from "../common/constants";
import { fieldActionConstants } from "../common/constants";
import { getApiValueKeys, objectMapping } from "./helper";
import { validationProcessor } from "./onLoad";
import { getFromLocalStorage, setInLocalStorage } from "./utility";

class FormProcessor {
	#_sectionValueMap;
	#_valueFieldStatus;
	#_isFieldAdded;
	#_valueFieldMap;
	#_activeSectionId;
	#_navigate;
	#_valueFieldMandatoryStatus;
	constructor() {
		this.#_sectionValueMap = {};
		this.#_valueFieldStatus = {};
		this.#_valueFieldMandatoryStatus = {};
		this.#_isFieldAdded = {};
		this.#_valueFieldMap = {};
		this.#_activeSectionId = "";
		this.#_navigate = {};
	}

	reset() {
		this.#_sectionValueMap = {};
		this.#_valueFieldStatus = {};
		this.#_isFieldAdded = {};
		this.#_valueFieldMap = {};
		this.#_navigate = {};
		this.#_valueFieldMandatoryStatus = {};
	}

	setNavigate(navigate) {
		this.#_navigate = navigate;
	}

	getNavigate() {
		return this.#_navigate;
	}

	addFormSections(sectionData, sectionState, sectionStatus) {
		this.#_sectionValueMap[sectionData.sectionId] = {
			fields: this.#_sectionValueMap[sectionData.sectionId]?.fields || [],
			sectionType: sectionData.sectionType,
			title: sectionData.title,
			subtitle: sectionData.subtitle,
			sectionState: sectionState,
			sectionStatus: sectionStatus,
			sectionId: sectionData.sectionId,
			updateSectionState: sectionData.updateSectionState,
			updateSectionStatus: sectionData.updateSectionStatus,
			status: this.#_sectionValueMap[sectionData.sectionId]?.status || false,
			mandatoryFields: this.#_sectionValueMap[sectionData.sectionId]?.mandatoryFields || new Set(),
			updateErrorInfoModal: sectionData?.updateErrorInfoModal,
			errorInfoModal: sectionData?.errorInfoModal,
			prefferedAction: sectionData?.prefferedAction,
			setPrefferedAction: sectionData?.setPrefferedAction,
			updateTitle: sectionData?.updateTitle,
			resetTitle: sectionData?.resetTitle,
			setStateStatus: sectionData?.setStateStatus,
			setShowActionLabel: sectionData?.setShowActionLabel,
			setLoader: sectionData?.setLoader
		};
	}

	setSectionStateAndPreferredAction(dependencyArray) {
		if (dependencyArray) {
			dependencyArray.forEach((item) => {
				if (
					typeof this.#_sectionValueMap[item.sectionId].setPrefferedAction ===
					"function"
				) {
					if (item?.stateStatus !== null && item?.stateStatus !== undefined) {
						this.#_sectionValueMap[item.sectionId].setPrefferedAction({
							...this.#_sectionValueMap[item.sectionId].prefferedAction,
							label: item.label,
							sectionState: item.sectionState,
							status: item.stateStatus
						});
					} else {
						this.#_sectionValueMap[item.sectionId].setPrefferedAction({
							...this.#_sectionValueMap[item.sectionId].prefferedAction,
							label: item.label,
							sectionState: item.sectionState,
						});
					}
					this.#_sectionValueMap[item.sectionId].updateSectionState(
						item.sectionState
					);
					item.sectionState === SECTIONSTATES.HIDDEN && this.updateSectionStatus(item.sectionId,true);
					item?.stateStatus !== null && item?.stateStatus !== undefined && this.#_sectionValueMap[item.sectionId].setStateStatus(item.stateStatus);
					this.saveToValueFieldMap(item.sectionId);
					this.updateSection(item.sectionId, "prefferedAction", {
						label: item.label,
						sectionState: item.sectionState,
					});
				}
				if (
					item?.updateFieldStatus &&
					Object.keys(item?.updateFieldStatus).length > 0
				) {
					const arr = Object.keys(item?.updateFieldStatus);
					arr.forEach((element) => {
						this.setValueFieldStatus(element, item.updateFieldStatus[element]);
						item?.resetValueFieldMap && this.resetValueFieldMap(element);
					});
				}
			});
		}
	}

	toggleBetweenSections(updatedSectionId, status = false) {
		const statusObject = !status
			? this.checkSectionStatus(this.getActiveSection())
			: { flag: status, incompleteFields: [] };
		if (statusObject.flag) {
			// this.onSectionStatusChangeAction(this.#_sectionValueMap[this.getActiveSection()]?.mandatoryFields);
			this.#_sectionValueMap[this.getActiveSection()]?.updateTitle &&
				this.#_sectionValueMap[this.getActiveSection()]?.updateTitle();
			this.setActiveSection(updatedSectionId);
			const keyarr = Object.keys(this.#_sectionValueMap);
			keyarr.forEach((item) => {
				this.saveToValueFieldMap(this.#_sectionValueMap[item].sectionId);
				if (
					typeof this.#_sectionValueMap[item].updateSectionState === "function"
				) {
					this.#_sectionValueMap[item].updateSectionState(
						updatedSectionId === item ? SECTIONSTATES.OPEN : SECTIONSTATES.CLOSE
					);
				}
			});
		} else {
			validationProcessor.validateAllFields(statusObject.incompleteFields)
		}
	}

	checkIfProceedToSectionAllowed(clickedSection, currentActive = this.getActiveSection()) {
		if (
			this.#_sectionValueMap[currentActive] &&
			this.#_sectionValueMap[currentActive].status
		) {
			const nextSection = this.getTheNextSection(currentActive);
			if (this.#_sectionValueMap[nextSection]?.prefferedAction?.sectionState === SECTIONSTATES.HIDDEN) {
				this.checkIfProceedToSectionAllowed(clickedSection, nextSection);
			}
			if (this.#_sectionValueMap[nextSection] && this.#_sectionValueMap[nextSection].status) {
				this.checkIfProceedToSectionAllowed(clickedSection, nextSection);
			}
			else {
				nextSection === clickedSection && this.toggleBetweenSections(clickedSection);
			}
		} else {
			const statusObject = this.checkSectionStatus(currentActive);
			if (statusObject.flag || (!statusObject.flag && this.#_sectionValueMap[currentActive]?.prefferedAction?.sectionState === SECTIONSTATES.HIDDEN)) {
				const nextSection = this.getTheNextSection(currentActive);
				if (nextSection === clickedSection) {
					this.toggleBetweenSections(clickedSection, true);
				}
			}
		}
	}

	displaySection(updatedSectionId) {
		const keyarr = Object.keys(this.#_sectionValueMap);
		keyarr.forEach((item) => {
			this.setActiveSection(updatedSectionId);
			this.saveToValueFieldMap(this.#_sectionValueMap[item].sectionId);
			if (
				typeof this.#_sectionValueMap[item].updateSectionState === "function"
			) {
				this.#_sectionValueMap[item].updateSectionState(
					updatedSectionId === item ? SECTIONSTATES.OPEN : SECTIONSTATES.CLOSE
				);
			}
		});
	}

	resetAllFields(updatedSectionId) {
		const keyarr = Object.keys(this.#_sectionValueMap);
		keyarr.forEach((item) => {
			if (this.#_sectionValueMap[item]?.fields && this.#_sectionValueMap[item]?.fields[0]) {
				updatedSectionId !== item && this.#_sectionValueMap[item].setStateStatus && this.#_sectionValueMap[item].setStateStatus(false);
				updatedSectionId === item && this.#_sectionValueMap[item].setStateStatus && this.#_sectionValueMap[item].setStateStatus(true);

				this.#_sectionValueMap[item].updateSectionStatus && this.#_sectionValueMap[item].updateSectionStatus(false);
				for (const field of this.#_sectionValueMap[item].fields) {
					field.resetValue && field.resetValue();
					this.setValueFieldStatus(field.fieldId, false);
				}
			}
			if (
				typeof this.#_sectionValueMap[item].updateSectionState === "function"
			) {
				this.#_sectionValueMap[item].updateSectionState(
					updatedSectionId === item ? SECTIONSTATES.OPEN : SECTIONSTATES.CLOSE
				);
			}
			this.#_sectionValueMap[item]?.resetTitle && this.#_sectionValueMap[item]?.resetTitle();
		});
		localStorage.removeItem("digicodeverifier");
	}

	changeSectionState(sectionId, state, errorInfo = null) {
		if (this.#_sectionValueMap && this.#_sectionValueMap[sectionId]) {
			if (
				typeof this.#_sectionValueMap[sectionId].updateSectionState ===
				"function"
			) {
				this.saveToValueFieldMap(sectionId);
				this.#_sectionValueMap[sectionId].updateSectionState(state);
				this.#_sectionValueMap[sectionId]?.setPrefferedAction && this.#_sectionValueMap[sectionId]?.prefferedAction && this.#_sectionValueMap[sectionId].setPrefferedAction({
					...this.#_sectionValueMap[sectionId].prefferedAction,
					sectionState: state,
				});
				if (
					errorInfo &&
					typeof this.#_sectionValueMap[sectionId]?.updateErrorInfoModal ===
					"function"
				) {
					this.#_sectionValueMap[sectionId].updateErrorInfoModal(errorInfo);
				}
			}
		}
	}

	onSectionStatusChangeAction(mandatoryFields) {
		if (mandatoryFields.size > 0) {
			for (let key of mandatoryFields) {
				this.updateField({
					fieldId: key,
					attributes: {
						disabled: true
					}
				}, { actionType: fieldActionConstants.UPDATE_ATTRIBUTES })
			}
		}
	}

	updateSection(sectionId, keyToUpdate, valueObject) {
		const section = this.#_sectionValueMap[sectionId];
		if (section) {
			this.#_sectionValueMap[keyToUpdate] = objectMapping(
				this.#_sectionValueMap[sectionId][keyToUpdate],
				valueObject
			);
		}
	}

	getSectionStatePrefferedAction(sectionId) {
		return (
			this.#_sectionValueMap[sectionId] &&
			this.#_sectionValueMap[sectionId]?.prefferedAction?.sectionState
		);
	}

	setActiveSection(sectionId) {
		this.#_activeSectionId = sectionId;
	}

	getActiveSection() {
		return this.#_activeSectionId;
	}

	getSectionStatus(sectionId) {
		return (
			this.#_sectionValueMap[sectionId] &&
			this.#_sectionValueMap[sectionId].status
		);
	}

	updateSectionStatus(sectionId, flag) {
		this.#_sectionValueMap[sectionId].status = flag;
	}

	checkSectionStatus(id) {
		const sectionId = id || this.getActiveSection();
		const incompleteFields = [];
		let flag = true;
		if (
			sectionId &&
			this.#_sectionValueMap &&
			this.#_sectionValueMap[sectionId] &&
			this.#_sectionValueMap[sectionId].mandatoryFields.size > 0
		) {
			for (const key of this.#_sectionValueMap[sectionId].mandatoryFields) {
				if (!this.getValueFieldStatus(key)) {
					this.updateSectionStatus(sectionId, false);
					incompleteFields.push(key);
					flag = false;
				}
				else {
					const field = this.getField(key);
					const errorInfo = validationProcessor.validateField({
						fieldId: key,
						fieldValue: this.getFieldValue(key),
						fieldData: field?.fieldData,
						type: field?.fieldData?.validation?.validationType || "default"
					});
					if (errorInfo.state !== STATES.NONE) {
						incompleteFields.push(key);
						flag = false;
					}
				}
			}
			flag && this.#_sectionValueMap[sectionId].updateSectionStatus(true);
			flag && this.updateSectionStatus(sectionId, true);
		} else {
			flag = false;
			this.updateSectionStatus(sectionId, false);
		}

		if (sectionId &&
			this.#_sectionValueMap &&
			this.#_sectionValueMap[sectionId] &&
			this.#_sectionValueMap[sectionId].fields &&
			this.#_sectionValueMap[sectionId].fields[0]) {
			for (const field of this.#_sectionValueMap[sectionId].fields) {
				if (!this.getValueFieldMandatoryStatus(field.fieldId)) {
					incompleteFields.push(field.fieldId);
					flag = false;
				}
			}
		}
		return { incompleteFields: incompleteFields, flag: flag };
	}

	checkIfOnlyOneSection(sectionType) {
		let formSections = 0;
		for (const section of Object.keys(this.#_sectionValueMap)) {
			if (this.#_sectionValueMap[section].sectionType === sectionType) {
				formSections++;
			}
		}
		return formSections === 1 ? true : false;
	}

	getTheNextSection(sectionId) {
		const keyarr = Object.keys(this.#_sectionValueMap);
		for (let key in keyarr) {
			if (sectionId == keyarr[key]) {
				return keyarr[parseInt(key) + 1];
			}
		}
		return undefined;
	}

	getSection(sectionId) {
		const keyarr = Object.keys(this.#_sectionValueMap);
		for (let key of keyarr) {
			if (sectionId == key) {
				return this.#_sectionValueMap[key];
			}
		}
		return undefined;
	}

	setActionLabel(sectionId, value) {
		this.#_sectionValueMap && this.#_sectionValueMap[sectionId] && this.#_sectionValueMap[sectionId].setShowActionLabel && this.#_sectionValueMap[sectionId].setShowActionLabel(value);
	}

	setValueFieldStatus(fieldId, value) {
		this.#_valueFieldStatus[fieldId] = value;
	}

	getValueFieldStatus(fieldId) {
		return this.#_valueFieldStatus && this.#_valueFieldStatus[fieldId]
			? this.#_valueFieldStatus[fieldId]
			: false;
	}

	setValueFieldMandatoryStatus(fieldId, value) {
		this.#_valueFieldMandatoryStatus[fieldId] = value;
	}

	getValueFieldMandatoryStatus(fieldId) {
		return this.#_valueFieldMandatoryStatus && this.#_valueFieldMandatoryStatus[fieldId] !== undefined
			? this.#_valueFieldMandatoryStatus[fieldId]
			: true;
	}

	addFieldToSection(fieldData, sectionId) {
		if (
			sectionId &&
			this.#_sectionValueMap[sectionId] &&
			!this.#_isFieldAdded[`${fieldData.fieldId}`]
		) {
			this.#_sectionValueMap[sectionId].fields.push(fieldData);
			this.#_isFieldAdded[`${fieldData.fieldId}`] = true;
			this.addMandatoryFields(fieldData, sectionId);
		} else {
			this.#_sectionValueMap[sectionId].fields = this.#_sectionValueMap[sectionId].fields.filter(field => field.fieldId !== fieldData.fieldId);
			this.#_sectionValueMap[sectionId].fields.push(fieldData);
		}
	}

	resetMandatoryFields(sectionId) {
		this.#_sectionValueMap[sectionId].mandatoryFields = new Set();
	}

	addMandatoryFields(fieldData, sectionId) {
		if (fieldData?.attributes && fieldData?.attributes?.required) {
			this.#_sectionValueMap[sectionId].mandatoryFields.add(fieldData.fieldId);
		}
	}

	updateMandatoryFields(sectionId, fields) {
		this.resetMandatoryFields(sectionId);
		if (this.#_sectionValueMap[sectionId]) {
			for (let key of fields) {
				const field = this.getField(key);
				this.addMandatoryFields(field, sectionId);
			}
		}
	}

	getFieldIdByFieldData(fieldData) {
		return fieldData.fieldId;
	}

	getField(fieldId) {
		for (const section of Object.keys(this.#_sectionValueMap)) {
			if (
				this.#_sectionValueMap[section] &&
				this.#_sectionValueMap[section].fields &&
				this.#_sectionValueMap[section].fields.length > 0
			) {
				const field = this.#_sectionValueMap[section].fields.filter(
					(currField) => currField.fieldId === fieldId
				);
				if (field.length > 0) {
					return field[0];
				}
			}
		}
	}

	getFieldUsingPrefix(fieldId) {
		for (const section of Object.keys(this.#_sectionValueMap)) {
			const field = this.#_sectionValueMap[section]?.fields?.filter((currField) =>
				currField.fieldId.startsWith(fieldId)
			);
			if (field?.length > 0) {
				return field;
			}
		}
	}

	deleteFieldUsingAppendById(fieldId) {
		for (const section of Object.keys(this.#_sectionValueMap)) {
			const field = this.#_sectionValueMap[section].fields.filter((currField) =>
				currField.appendById === fieldId
			);

			if (field.length > 0) {
				this.#_sectionValueMap[section].fields = this.#_sectionValueMap[section].fields.filter((currField) => {
					if (currField.appendById === fieldId) {
						this.#_valueFieldMap[currField.fieldId] = undefined;
					}

					return currField.appendById !== fieldId
				}
				);
				return;
			}
		}
	}

	getAllFieldsInASection(sectionId) {
		if (sectionId && this.#_sectionValueMap[sectionId]) {
			return this.#_sectionValueMap[sectionId].fields;
		}
	}

	getFieldValue(fieldId) {
		const field = this.getField(fieldId);
		return field?.fieldValue;
	}

	updateParentField(fieldId, itemArray) {
		for (const section of Object.keys(this.#_sectionValueMap)) {
			if (
				this.#_sectionValueMap[section] &&
				this.#_sectionValueMap[section].fields &&
				this.#_sectionValueMap[section].fields.length > 0
			) {
				this.#_sectionValueMap[section].fields.map( (currField) => {
					if(currField.fieldId === fieldId) {
						if(currField?.parentFields && currField?.parentFields.length > 0) {
								currField.parentFields = currField?.parentFields.concat(itemArray);
						}
					}
				});
			}
		}
	}
	updateField(fieldData, entity) {
		const field = this.getField(fieldData.fieldId);
		if (field) {
			const actionType = entity.actionType;
			switch (actionType) {
				case fieldActionConstants.UPDATE_ATTRIBUTES: {
					field.fieldValue = fieldData?.fieldValue || field.fieldValue;
					field.attributes = objectMapping(
						field.attributes,
						fieldData.attributes
					);
					field.attributeListener &&
						field.attributeListener({
							value: field.fieldValue,
							checked: field.checked,
							attributes: field.attributes,
							metric: fieldData.metric,
							options: fieldData?.options || field?.fieldOptions || []
						});
					break;
				}
				case fieldActionConstants.UPDATE_CHECKED: {
					field.checked = fieldData.checked;
					field.fieldValue = fieldData?.fieldValue;
					if (fieldData?.saveToFilter) {
						field.filter.selectedValue = field.fieldValue
					}
					field.entityListener &&
						field.entityListener({
							value: field.fieldValue,
							checked: field.checked,
							options: field.fieldOptions,
							filter: field?.filter,
							metric: fieldData?.metric,
						});
					break;
				}
				case fieldActionConstants.ENABLE_FILTER: {
					const toFilterBy = getApiValueKeys(fieldData.filter.value, fieldData);
					field.filter.value = toFilterBy;
					field.filter.enable = fieldData.filter.enable;
					field.filterListener &&
						field.filterListener({
							filter: field.filter,
							options: field.fieldOptions,
							metric: fieldData?.metric,
						});
					break;
				}
				case fieldActionConstants.UPDATE_OPTIONS: {
					field.fieldOptions = fieldData.fieldOptions;
					field.entityListener &&
						field.entityListener({
							options: field.fieldOptions,
							metric: fieldData?.metric,
						});
					break;
				}
				case fieldActionConstants.UPDATE_VALUE: {
					field.fieldValue = fieldData?.fieldValue;
					field.checked = fieldData?.checked;
					field.errorInfo = objectMapping(
						field?.errorInfo,
						fieldData?.errorInfo
					);
					field.entityListener &&
						field.entityListener({
							value: field.fieldValue,
							options: field.fieldOptions,
							metric: fieldData.metric,
						});
					break;
				}
				case fieldActionConstants.UPDATE_ERRORINFO: {
					field.errorInfo = objectMapping(field.errorInfo, fieldData.errorInfo);
					field.fieldValue = fieldData?.fieldValue || field.fieldValue;
					field.errorListener &&
						field.errorListener({
							value: field.fieldValue,
							errorInfo: fieldData.errorInfo,
							metric: fieldData?.metric,
						});
					break;
				}
			}
		}
	}

	updateLoaderState(sectionId, state) {
		if(this.#_sectionValueMap[sectionId] && this.#_sectionValueMap[sectionId]?.setLoader) {
			 this.#_sectionValueMap[sectionId]?.setLoader(state)
		}
	}

	resetValueFieldMap(fieldId) {
		this.#_valueFieldMap[fieldId] = {};
	}

	getValueFieldMap(fieldId) {
		return this.#_valueFieldMap && this.#_valueFieldMap[fieldId];
	}

	saveToValueFieldMap(sectionId) {
		const allFields = this.getAllFieldsInASection(
			sectionId || this.getActiveSection()
		);
		if (allFields && allFields.length > 0) {
			for (const key of allFields) {
				this.#_valueFieldMap[key.fieldId] = key;
			}
		}
	}

	saveValuesToLocalStorage() {
		try {
			const parseData = getFromLocalStorage(SKYC_MODULE_NAME, SKYC_KEY_NAME);
			if (parseData) {
				const newData = objectMapping(parseData, this.#_valueFieldMap);
				setInLocalStorage(
					SKYC_MODULE_NAME,
					SKYC_KEY_NAME,
					JSON.stringify(newData)
				);
			} else
				setInLocalStorage(
					SKYC_MODULE_NAME,
					SKYC_KEY_NAME,
					JSON.stringify(this.#_valueFieldMap)
				);
		} catch (err) {
			console.error(err);
		}
	}

	// Method to find the next focusable button in a section
	findNextFocusableButton(sectionId, currentFieldId) {
		const sectionFields = this.getAllFieldsInASection(sectionId);
		if (sectionFields) {
			// Find button fields in the same section that have a focusButton method
			const buttonField = sectionFields.find(field => 
				field.fieldId !== currentFieldId && 
				field.focusButton && 
				typeof field.focusButton === 'function' &&
				field.attributes && 
				!field.attributes.disabled
			);
			
			return buttonField;
		}
		return null;
	}
}

export { FormProcessor };
